var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "app-card",
            {
              attrs: {
                heading: "Launch WHM"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    color: "success",
                    tile: ""
                  },
                  on: {
                    click: function click($event) {
                      return _vm.launch_whm(_vm.hostingid)
                    }
                  }
                },
                [_vm._v("Launch WHM")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }